
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import React from 'react'
import { createUseStyles } from 'react-jss'
import { Gallery, Item } from 'react-photoswipe-gallery'
import { connect } from 'react-redux'

const CustomGallery = (props) => {
  const { page, alt } = props
  const classes = useStyles()
  const importAll = (r) => {
    return r.keys().map(r).map(r => r.default)
  }

  const images = {
    'green-school': importAll(require.context('../../images/green-school/', false, /\.(png|jpe?g|svg)$/)),
    'winter-holidays': importAll(require.context('../../images/winter-holidays/', false, /\.(png|jpe?g|svg)$/)),
  }

  return (
  <Gallery>
    <div className={classes.customGallery}>
    {images[page].map((image, index) => (
      <Item
        key={image}
        original={image}
        thumbnail={image}
        width="646"
        height="468"
      >
      {({ ref, open, }) => (
        <img alt={`${alt}${index + 1}`}ref={ref} onClick={open} src={image} />
      )}
      </Item>
    ))}

    </div>
  </Gallery>
)}
const useStyles = createUseStyles({
  customGallery: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '& img': {
      width: '33%',
      marginBottom: '0em',
      cursor: 'pointer',
      padding: '0.5px',
    },
  },
})

const mapStateToProps = (state) => {
  return {
    alt: state.translations.translations.offer_page.carousel_img_alt,
  }
}

export default connect(mapStateToProps)(CustomGallery)
